import { z } from "zod";

/**
 * An end user as other shoppers may see them (boxed parity: the profile quick view's identity
 * and Player Stats). Read from `GET /v1/profiles/{endUserId}` with any key or a session; the
 * storefront opens it from a battle seat. Never an external id, an email, a balance or a lock:
 * the response is built from an allowlist, not the end-user row.
 */
export const publicProfileStatsSchema = z.object({
  /** Boxes opened, one per box (a multi-open of N counts N). */
  boxesOpened: z.int(),
  /** Completed battles the user held a seat in. */
  battlesPlayed: z.int(),
  /** Of those, the ones their seat won. */
  battlesWon: z.int(),
});
export type PublicProfileStats = z.infer<typeof publicProfileStatsSchema>;

export const publicProfileSchema = z.object({
  /** The end user's id: what a battle seat's `endUser.id` carries. */
  id: z.string(),
  /** The username once chosen, else `Player XXXX`: the same name a battle seat shows. */
  displayName: z.string(),
  /** When the user was created, ISO 8601. */
  memberSince: z.string(),
  stats: publicProfileStatsSchema,
});
export type PublicProfile = z.infer<typeof publicProfileSchema>;

/** GET /v1/profiles/{endUserId}. */
export const publicProfileResponseSchema = z.object({ profile: publicProfileSchema });
export type PublicProfileResponse = z.infer<typeof publicProfileResponseSchema>;
